import { render } from "./calendarOld.vue?vue&type=template&id=1de3c9f8&scoped=true&ts=true"
import script from "./calendarOld.vue?vue&type=script&lang=ts"
export * from "./calendarOld.vue?vue&type=script&lang=ts"

import "./calendarOld.vue?vue&type=style&index=0&id=1de3c9f8&scoped=true&lang=css"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de3c9f8"]])

export default __exports__